<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ $route.meta.title }}
          <el-button class="title_btn" @click="moveCreate" type="primary">등록</el-button>
        </div>

      <div class="list-content">
          <ssam-talk-category-list-component :ssam-talk-type="'category'"></ssam-talk-category-list-component>
        </div>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
  <!-- <div class="container lnb d_container">
    <div class="contents_wrap">
        <div class="contents list-container node_centent">
            <div class="title">
              {{ $route.meta.title }}
                <div class="refund_caption pt5">
                    하위 카테고리들은 APP에서 이름 오름차순으로 우선노출 합니다.
                </div>
            </div>
            <div class="">
              <ssam-talk-category-component :categoryType="'categoryBasic'"></ssam-talk-category-component>
            </div>
        </div>
        <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>

    </div> -->
</div>
</template>

<script>

import SsamTalkListComponent from "@/components/ssamtalk/SsamTalkListComponent.vue";
import SsamTalkCategoryListComponent from "@/components/ssamtalk/SsamTalkCategoryListComponent.vue";
import SsamTalkCategoryComponent from "@/components/ssamtalk/SsamTalkCategoryComponent";
export default {
  name: "SsamTalkCategory",
  mixins: [],
  components: {SsamTalkCategoryListComponent, SsamTalkCategoryComponent},
  provide() {
    return {};
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    moveCreate(){
      this.$router.push('/ssamtalk/categories/create')
    }
  },
  watch: {},
};
</script>
